

<div *ngIf="isloading; else loadedBox" class="w-100 t-a-center">
  Завантаження...
</div>

<ng-template #loadedBox>

<div *ngIf="model.length > 0; else emptyBox" #qsContainer class="si-queues">

    <div *ngIf="sizes.isWider" class="nav-btn-box">
      <button kendoButton 
        icon="arrow-chevron-left" 
        [disabled]="sizes.btnsQueuesScrollLeft == 0" 
        (click)="move('back')"
        themeColor="primary">
      </button>
    </div>

    <div #qsScrollable class="qs-scrollable" [style.height.px]="sizes.qsContainerHight" [style.width.px]="sizes.btnsQueuesWidth">
      <div class="qs-items-box" [style.height.px]="sizes.qsContainerHight + 20" [style.width.px]="sizes.evaluatedWidth + 20">

        <div class="qs-items-box-h" [style.width.px]="sizes.evaluatedWidth">
          <div *ngFor="let day of model; let i = index" class="qs-items-box-h-cell" [class.b-none] = "i === 0">
            {{ day.dayOfWeek }} <br />
            {{ day.date  | date : 'dd,' }} {{ day.monthGenShort }}
          </div>
        </div>

        <div class="qs-items-box-btns" [style.width.px]="sizes.evaluatedWidth">
          <div *ngFor="let x of model" class="qs-items-box-btns-cell">
            <button *ngFor="let xx of x.apps" 
              kendoButton 
              fillMode="outline" 
              (click)="queueSelected.emit(xx)"
            > 
              {{ xx.timeBegin }} 
            </button>
            <br /><br />
          </div>
        </div>

      </div>
    </div>

    <div *ngIf="sizes.isWider" class="nav-btn-box" [style.left.px]="sizes.qsContainerWidth - 40">
      <button kendoButton 
        icon="arrow-chevron-right" 
        [disabled]="sizes.btnsQueuesScrollLeft == sizes.maxOffset"  
        (click)="move('forward')" 
        themeColor="primary">
      </button>
    </div>

</div>

<ng-template #emptyBox>
  <div class="w-100 t-a-center">
    На даний напрямок прийоми відсутні. Оберіть інший напрямок.
  </div>
</ng-template>

</ng-template>
